<template>
  <div>

    <TopButtonsComponent
      :jobCreatorId="creatorId"
      v-on:backToJobs="$emit('backToJobs', 'Jobs')"
      v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
    />

    <div class="post-job-container" v-if="!loading">

      <div class="left-content">
        <div class="form-field">
          <h3>Job Title <span class="required">*</span></h3>
          <input
            name="jobTitle"
            type="text"
            v-model="formData.jobTitle"
            v-on:change="validateText"
            required
          />
          <p v-if="error.jobTitleError" class="error-text">
            Please enter a valid input
          </p>
        </div>

        <div class="form-field">
          <h3>Description <span class="required">*</span></h3>
          <textarea
            type="text"
            name="jobDescription"
            v-model="formData.jobDescription"
            placeholder="For multiple comments or to add new lines, press the enter key"
            rows="4"
            v-on:change="validateText"
            required
          />
          <p v-if="error.jobDescriptionError" class="error-text">
            Please enter at least 20 characters
          </p>
        </div>

        <div class="form-field">
          <h3>Upload Job Cover Photo <span class="file-size">(max 2MB - JPG or PNG)</span></h3>
          <div
            v-if="!viewImage"
            class="upload-image"
            @click="$refs.myFile.click()"
          >
            <span>
              <img src="../../assets/images/upload-logo.png" alt="upload icon"/>
            </span>
            <span>
              <p>Upload Job Cover Photo</p>
            </span>
            <input
              type="file"
              placeholder="Upload CoverImage"
              ref="myFile"
              @change="selectedFile"
              hidden
            />
            <h6>Add a cover image that will be seen by candidates</h6>
          </div>
          <div
            v-if="viewImage"
            class="upload-image"
            v-on:click="resetImage"
          >
            <span>
              <img class="preview-image" :src="viewImage" alt="Preview image" />
            </span>
            <span>
              <p>Remove Image</p>
            </span>
          </div>
          <div v-if="imageError">
            <p class="error-text">
              Please select an image no more than the specified file size and type.
            </p>
            <span v-on:click="clearImageError" class="clear-image-error">
              **Click to continue without uploading a cover image.
            </span>
          </div>
        </div>

        <div class="form-field">
          <h3>Specialization <span class="required">*</span></h3>
          <select
            name="specialization"
            v-model="formData.specialization"
            v-on:change="validateText"
            required
          >
            <option
              v-for="(item, index) in specializationList"
              :key="index"
              :value="item.value"
            >
              {{ item.title }}
            </option>
          </select>
          <p v-if="error.specializationError" class="error-text">
            Please enter a valid input
          </p>
        </div>

        <div class="form-field">
          <h3>Experience Level <span class="required">*</span></h3>
          <select
            name="experienceLevel"
            v-model="formData.experienceLevel"
            v-on:change="validateText"
            required
          >
            <option
              v-for="(item, index) in experienceLevelList"
              :key="index"
              :value="item.value"
            >
              {{ item.title }}
            </option>
          </select>
          <p v-if="error.experienceLevelError" class="error-text">
            Please enter a valid input
          </p>
        </div>

        <div class="form-field">
          <h3>Job Type <span class="required">*</span></h3>
          <select
            name="jobType"
            v-model="formData.jobType"
            v-on:change="validateText"
            required
          >
            <option
              v-for="(item, index) in jobTypeList"
              :key="index"
              :value="item.value"
            >
              {{ item.title }}
            </option>
          </select>
          <p v-if="error.jobTypeError" class="error-text">
            Please enter a valid input
          </p>
        </div>
      </div>

      <div class="right-content">
        <div class="form-field">
          <h3>City <span class="required">*</span></h3>
          <input
            name="jobCity"
            type="text"
            v-model="formData.jobCity"
            v-on:change="validateText"
            required
          />
          <p v-if="error.jobCityError" class="error-text">
            Please enter at least 3 characters
          </p>
        </div>

        <div class="form-field">
          <h3>State/Province <span class="required">*</span></h3>
          <input
            name="jobState"
            type="text"
            v-model="formData.jobState"
            v-on:change="validateText"
            required
          />
          <p v-if="error.jobStateError" class="error-text">
            Please enter at least 3 characters
          </p>
        </div>

        <div class="form-field">
          <h3>Job Deadline <span class="required">*</span></h3>
          <input
            name="jobDeadline"
            type="date"
            v-model="formData.jobDeadline"
            v-on:change="validateText"
            required
          />
          <p v-if="error.jobDeadlineError" class="error-text">
            Please enter a valid input
          </p>
        </div>

        <div class="form-field" v-if="showCompanyName">
          <h3>
            Company Name
            <span class="required">*</span>
            <span class="hint">(Name of the company you are hiring for)</span>
          </h3>
          <input
            name="companyName"
            type="text"
            v-model="companyName"
            v-on:change="validateText"
            required
          />
          <p v-if="companyNameError" class="error-text">
            Please enter a valid input
          </p>
        </div>

        <div class="form-field question">
          <h3>Question 1 <span class="hint">(Optional - should be a Yes/No question)</span></h3>
          <input
            name="questionOne"
            type="text"
            v-model="formData.questionOne"
            v-on:change="validateText"
            placeholder="e.g. Do you meet the job minimum requirements?"
          />
          <p v-if="error.questionOneError" class="error-text">
            Please enter a minimum of five characters
          </p>
        </div>

        <div class="form-field question">
          <h3>Question 2 <span class="hint">(Optional - should be a Yes/No question)</span></h3>
          <input
            name="questionTwo"
            type="text"
            v-model="formData.questionTwo"
            v-on:change="validateText"
            placeholder="e.g. Do you have the required job experience?"
          />
          <p v-if="error.questionTwoError" class="error-text">
            Please enter a minimum of five characters
          </p>
        </div>

        <div class="form-field question">
          <h3>Question 3 <span class="hint">(Optional - should be a Yes/No question)</span></h3>
          <input
            name="questionThree"
            type="text"
            v-model="formData.questionThree"
            v-on:change="validateText"
            placeholder="e.g. Are you available for immediate employment?"
          />
          <p v-if="error.questionThreeError" class="error-text">
            Please enter a minimum of five characters
          </p>
        </div>

        <div class="form-field video-cv-guide">
          <h3>Video Questions/Guide <span class="hint">(Optional)</span></h3>
          <textarea
            name="videoGuide"
            v-model="formData.videoGuide"
            v-on:change="validateText"
            rows="4"
            placeholder="Please specify any questions or guidelines you would like the candidate to address in their video (if applicable). For multiple comments, press the enter key"
          />
          <p v-if="error.videoGuideError" class="error-text">
            Please enter a minimum of five characters
          </p>
        </div>

        <div class="submit-button-container">
          <button :disabled="disable" @click="handleSubmit">Create Job</button>
        </div>

      </div>
    </div>

    <!-- Loader -->
    <div class="loading-text" v-if="loading">
      <p>Please wait</p>
      <div v-bind:class="{ loading: loading }"></div>
    </div>

    <!-- Modal component for Successful Job Post -->
    <div v-if="showSuccessModal">
      <SuccessModal
        v-on:closeSuccessModal="showSuccessModal = false"
        v-bind:successImage="successImage"
        v-bind:successTitle="'Success!'"
        v-bind:successMessage="'Job has successfully been created'"
      />
    </div>

  </div>
</template>

<script>
import TopButtonsComponent from '../JobDetail/TopButtonsComponent.vue';
import SuccessModal from '../Modals/SuccessModal.vue';
import successImage from '../../assets/images/success-logo.png';
export default {
  name: 'CreateJob',
  props: ['jobCreatorId'],
  components: { TopButtonsComponent, SuccessModal },
  data() {
    return {
      formData: {
        jobTitle: null,
        jobDescription: null,
        jobType: null,
        jobCity: null,
        jobState: null,
        jobDeadline: null,
        specialization: null,
        experienceLevel: null,
        questionOne: null,
        questionTwo: null,
        questionThree: null,
        videoGuide: null
      },
      error: {
        jobTitleError: false,
        jobDescriptionError: false,
        specializationError: false,
        experienceLevelError: false,
        jobTypeError: false,
        jobCityError: false,
        jobStateError: false,
        jobDeadlineError: false,
        questionOneError: false,
        questionTwoError: false,
        questionThreeError: false,
        videoGuideError: false
      },

      companyNameError: false,
      imageError: false,

      successImage: null,
      companyName: null,
      showCompanyName: false,

      experienceLevelList: [
        { title: 'Advanced', value: 'advanced' },
        { title: 'Senior', value: 'senior' },
        { title: 'Intermediate (Mid-level)', value: 'intermediate' },
        { title: 'Junior', value: 'junior' },
        { title: 'Beginner', value: 'beginner' },
        { title: 'Intern', value: 'intern' },
      ],
      specializationList: [
        { title: 'Technology', value: 'Technology' },
        { title: 'Product Design', value: 'Product Design' },
        { title: 'Product Management', value: 'Product Management' },
        { title: 'Project Management', value: 'Project Management' },
        { title: 'Administration', value: 'Administration' },
        { title: 'Education', value: 'Education' },
        { title: 'Operations', value: 'Operations' },
        { title: 'Sales', value: 'Sales' },
        { title: 'Marketing', value: 'Marketing' },
        { title: 'Customer Service', value: 'Customer Service' },
        { title: 'Human Resources', value: 'Human Resources' },
        { title: 'Creative & Design', value: 'Creative and Design' },
        { title: 'Media & Communications', value: 'Media and Communications' },
        { title: 'Health & Wellness', value: 'Health and Wellness' },
        { title: 'Hospitality & Tourism', value: 'Hospitality and Tourism' },
        { title: 'Arts & Entertainment', value: 'Arts and Entertainment' },
        { title: 'Science & Research', value: 'Science and Research' },
        { title: 'Agriculture', value: 'Agriculture' },
        { title: 'Finance', value: 'Finance' },
        { title: 'Supply Chain', value: 'Supply Chain' },
        { title: 'Engineering', value: 'Engineering' },
        {
          title: 'Building & Construction',
          value: 'Building and Construction',
        },
        {
          title: 'Logistics & Transportation',
          value: 'Logistics and Transportation',
        },
        { title: 'Legal', value: 'Legal' },

        { title: 'Energy & Utilities', value: 'Energy and Utilities' },
        { title: 'Telecommunications', value: 'Telecommunications' },
        {
          title: 'Petroleum & Petrochemicals',
          value: 'Petroleum and Petrochemicals',
        },
        {
          title: 'Furniture & Interior Design',
          value: 'Furniture and Interior Design',
        },
        {
          title: 'Manufacturing',
          value: 'Manufacturing'
        },
        {
          title: 'Healthcare',
          value: 'Healthcare'
        },
        {
          title: 'Others',
          value: 'Others'
        },
      ],
      jobTypeList: [
        { title: 'Full Time', value: 'Full Time' },
        { title: 'Full Time - Remote', value: 'Full Time - Remote' },
        { title: 'Full Time - Hybrid', value: 'Full Time - Hybrid' },
        { title: 'Part Time', value: 'Part Time' },
        { title: 'Part Time - Remote', value: 'Part Time - Remote' },
        { title: 'Part Time - Hybrid', value: 'Part Time - Hybrid' },
        { title: 'Contract', value: 'Contract' },
        { title: 'Contract - Remote', value: 'Contract - Remote' },
        { title: 'Contract - Hybrid', value: 'Contract - Hybrid' },
        { title: 'Internship', value: 'Internship' },
      ],

      jobCoverPhoto: null,
      viewImage: null,

      disable: false,
      loading: false,

      creatorId: this.jobCreatorId,
      showSuccessModal: false,
      imageUploadError:
      'We accept only jpeg, png files of not more than 2MB.',
    };
  },
  methods: {
    selectedFile(event) {
      if ((event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png') &&
        event.target.files[0].size <= 2000000 ) {
        this.jobCoverPhoto = event.target.files[0];
        this.viewImage = URL.createObjectURL(this.jobCoverPhoto);
        this.imageError = false;
      } else {
        this.imageError = true;
        this.$toastr.error(this.imageUploadError, 'Wrong File Type/Size:');
      }
    },
    resetImage() {
      this.jobCoverPhoto = null;
      this.viewImage = null;
    },
    clearImageError () {
      this.imageError = false;
      this.disable = false; //reset button disabled attribute
    },
    handleSubmit() {
      if (
        this.error.jobTitleError ||
          !this.formData.jobTitle ||
          this.error.jobDescriptionError ||
          !this.formData.jobDescription ||
          this.error.specializationError ||
          !this.formData.specialization ||
          this.error.experienceLevelError ||
          !this.formData.experienceLevel ||
          this.error.jobTypeError ||
          !this.formData.jobType ||
          this.error.jobCityError ||
          !this.formData.jobCity ||
          this.error.jobStateError ||
          !this.formData.jobState ||
          this.error.jobDeadline ||
          !this.formData.jobDeadline ||
          this.error.questionOneError ||
          this.error.questionTwoError ||
          this.error.questionThreeError ||
          this.error.videoGuideError
      ) {
        Object.keys(this.formData).forEach((field) => {
          if ((field !== 'questionOne' && field !== 'questionTwo' && field !== 'questionThree' && field !== 'videoGuide') &&
          !this.formData[field]) {
            this.error[`${field}Error`] = true;
          }
        });
      } else if (this.imageError === true) {
        // Set disabled attribute to the Create Job button
        this.disable = true;
      } else {
        if (
          this.showCompanyName &&
            (this.companyNameError || !this.companyName)
        ) {
          this.companyNameError = true;
        } else {
          this.imageError = false;
          this.loading = true;

          let expectedJobFormat = {
            title: this.formData.jobTitle,
            jobDescription: this.formData.jobDescription,
            employmentType: this.formData.jobType,
            jobDeadline: this.formData.jobDeadline,
            category: this.formData.specialization,
            experienceLevel: this.formData.experienceLevel,
            city: this.formData.jobCity,
            state: this.formData.jobState,
          };

          this.showCompanyName
          ? expectedJobFormat['companyName'] = this.companyName
          : null;

          this.formData.questionOne
          ? expectedJobFormat['applicantQuestionOne'] = this.formData.questionOne
          : null;

          this.formData.questionTwo
          ? expectedJobFormat['applicantQuestionTwo'] = this.formData.questionTwo
          : null;

          this.formData.questionThree
          ? expectedJobFormat['applicantQuestionThree'] = this.formData.questionThree
          : null;

          this.formData.videoGuide
          ? expectedJobFormat['videoCvGuide'] = this.formData.videoGuide
          : null;

          this.$store
            .dispatch('postJob', [expectedJobFormat, this.jobCoverPhoto])
            .then((res) => {
              if (res.response) {
                this.successImage = successImage;
                this.showSuccessModal = true;

                // Reset form
                Object.keys(this.formData).forEach((field) => {
                  this.formData[`${field}`] = null;
                });

                this.companyName = null;
                this.jobCoverPhoto = null;
                this.viewImage = null;

                setTimeout(() => {
                  this.showSuccessModal = false;
                }, 5000);

              } else if (res.error) {
                this.$toastr.error(res.error, 'Failed');
              }

              this.loading = false;

            })
            .catch((err) => {
              this.loading = false;
              this.$toastr.error(
                err ? err : 'Error occured while attempting to create job',
                'Failed'
              );
            });
        }
      }
    },
    validateText(e) {
      this.disable = false;
      let fieldName = e.target.name;
      let fieldValue = e.target.value;

      switch (fieldName) {
        case 'jobTitle':
          if (fieldValue.trim() === '' || fieldValue.trim().length < 3) {
            this.error.jobTitleError = true;
          } else {
            this.error.jobTitleError = false;
          }
          break;

        case 'jobDescription':
          if (fieldValue.trim() === '' || fieldValue.trim().length < 20) {
            this.error.jobDescriptionError = true;
          } else {
            this.error.jobDescriptionError = false;
          }
          break;

        case 'specialization':
          if (fieldValue.trim() === '') {
            this.error.specializationError = true;
          } else {
            this.error.specializationError = false;
          }
          break;

        case 'experienceLevel':
          if (fieldValue.trim() === '') {
            this.error.experienceLevelError = true;
          } else {
            this.error.experienceLevelError = false;
          }
          break;

        case 'jobType':
          if (fieldValue.trim() === '') {
            this.error.jobTypeError = true;
          } else {
            this.error.jobTypeError = false;
          }
          break;

        case 'jobCity':
          if (fieldValue.trim() === '' || fieldValue.trim().length < 3) {
            this.error.jobCityError = true;
          } else {
            this.error.jobCityError = false;
          }
          break;

        case 'jobState':
          if (fieldValue.trim() === '' || fieldValue.trim().length < 3) {
            this.error.jobStateError = true;
          } else {
            this.error.jobStateError = false;
          }
          break;

        case 'jobDeadline':
          if (fieldValue.trim() === '') {
            this.error.jobDeadlineError = true;
          } else {
            this.error.jobDeadlineError = false;
          }
          break;

        case 'companyName':
          if (fieldValue.trim() === '' || fieldValue.trim().length < 3) {
            this.companyNameError = true;
          } else {
            this.companyNameError = false;
          }
          break;

        case 'questionOne':
          if (fieldValue.trim() !== '' && fieldValue.trim().length < 5) {
            this.error.questionOneError = true;
          } else {
            this.error.questionOneError = false;
          }
          break;

        case 'questionTwo':
          if (fieldValue.trim() !== '' && fieldValue.trim().length < 5) {
            this.error.questionTwoError = true;
          } else {
            this.error.questionTwoError = false;
          }
          break;

        case 'questionThree':
          if (fieldValue.trim() !== '' && fieldValue.trim().length < 5) {
            this.error.questionThreeError = true;
          } else {
            this.error.questionThreeError = false;
          }
          break;

        case 'videoGuide':
          if (fieldValue.trim() !== '' && fieldValue.trim().length < 5) {
            this.error.videoGuideError = true;
          } else {
            this.error.videoGuideError = false;
          }
          break;

      }
    },
  },
  beforeMount() {
    this.$store.state.userData.userType !== 'business'
      ? (this.showCompanyName = true)
      : (this.showCompanyName = false);
  },
};
</script>
<style scoped>
  @keyframes buttonLoadingSpinner {
    from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
  }

  .loading-text {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 50px;
    color: white;
    justify-content: center;
  }
  .loading::after {
    content: "";
    position: absolute;
    width: 100px;
    height: 100px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: var(--white);
    border-right-color: var(--white);
    border-radius: 50%;
    animation: buttonLoadingSpinner 1s linear infinite;
  }
  .post-job-container {
    background: var(--white);
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 15px;
    display: flex;
    flex-direction: row;
    padding: 30px;
    justify-content: space-between;
    min-height: 1050px;
  }
  .left-content,
  .right-content {
    width: 45%;
  }
  .right-content {
    padding-right: 20px;
  }
  .left-content {
    padding-left: 20px;
  }

  h3 {
    font-family: "montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    line-height: 1.25rem;
    color: var(--colorSecondary);
    padding-bottom: 16px;
  }
  select,
  input,
  textarea {
    width: 100%;
    max-width: 100%;
    height: 40px;
    box-shadow: 0px 0px 4px 2px rgba(39, 31, 31, 0.15);
    border-radius: 5px;
    outline: none;
    padding: 10px;
    font-family: 'montserrat';
    font-size: 1rem;
    color: rgba(51, 52, 54, 0.7);
    line-height: 1.25rem;
    /* identical to box height */
    -webkit-appearance: auto;
    color: rgba(51, 52, 54, 0.7);
  }
  .form-field {
    margin-bottom: 30px;
  }
  .upload-image,
  textarea {
    height: 150px;
    max-height: 150px;
    resize: none;
  }
  .upload-image {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border: 1px dashed #071a52;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 15px;
    cursor: pointer;
  }
  .upload-image img {
    margin-bottom: 10px;
  }
  .upload-image p {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: bold;
    font-size: 17px;
    line-height: 21px;
    color: var(--colorSecondary);
    margin-bottom: 8px;
    cursor: pointer;
  }
  .file-size {
    font-size: 12px;
  }
  .preview-image {
    width: 30px;
    height: 30px;
  }
  .upload-image h6 {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #828282;
  }
  .required,
  .error-text {
    color: tomato;
  }
  .hint {
    font-size: 12px;
    margin-left: 7px;
    /* color: var(--black); */
    color: #828282;
    vertical-align: middle;
  }
  .error-text {
    margin-top: 15px;
  }
  .clear-image-error {
    cursor: pointer;
    font-size: 15px;
    text-decoration: underline;
    display: block;
    margin-top: 10px;
  }
  .question input::placeholder,
  .video-cv-guide textarea::placeholder {
    font-size: 13px;
  }
  .submit-button-container {
    margin-top: 80px;
  }
  .submit-button-container button {
    background: var(--colorPrimary);
    color: var(--white);
    width: 188px;
    height: 53px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
    border-radius: 5px;
    float: right;
    outline: none;
  }

  /* RESPONSIVENESS */
  @media only screen and (max-width: 850px) {
    .post-job-container {
      display: block;
      min-height: 1600px;
    }
    .left-content,
    .right-content {
      width: 100%;
    }
    .left-content {
      padding-left: unset;
    }
    .right-content {
      padding-right: unset;
    }
    .submit-button-container {
      margin-top: 40px;
    }
  }
  @media only screen and (max-width: 767px) {

  }
</style>
